
















import {Component} from 'vue-property-decorator';
import Vue from 'vue';

class AgCol extends Vue {
    params!: {
        data: {
            id: number,
            form: {
                id: number
                progress: number

            }
        }
    };
}

@Component({})
export default class FormIndexActions extends AgCol {
    get progress(): number {
        if (this.params.data.form) {
            return this.params.data.form.progress;
        }

        return 0;
    }



}
